import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";

const Department = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');
    const uname = sessionStorage.getItem('uname');
    
    const [accessibleDepartments, setAccessibleDepartments] = useState([]);

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments = [] } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments = [] } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });
    
    useEffect(() => {
        const combineDepartments = [...manageddepartments, ...managedadjustments];
        const finalDepartments = combineDepartments.filter((value, index, self) => (
            index === self.findIndex((d) => (
                d.department_code === value.department_code && d.department === value.department
            ))
        ));

        if (JSON.stringify(finalDepartments) !== JSON.stringify(accessibleDepartments)) {
            setAccessibleDepartments(finalDepartments);
        }
        console.log(managedadjustments)
    }, [manageddepartments, managedadjustments, accessibleDepartments]);

    const { data: departments, isLoading: isLoadingDepartments, error: errorDepartments } = useQuery({
        queryKey: ['departments'],
        queryFn: async () => {
            const res = await axios.get('departments', {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        }
    });

    useEffect(() => {
        if (errorDepartments?.response?.data.status === 'inactive') {
            destroySession();
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
        }
    }, [errorDepartments, navigate]);

    const handleSetTimesheetChildData = (department, slug) => {
        // MSW-26192: Clear employee data when navigating to a different department
        sessionStorage.removeItem('timesheetEmployee');
        sessionStorage.removeItem('timesheetEmployeeUname');

        sessionStorage.setItem('timesheetChild', department);
        sessionStorage.setItem('timesheetChildSlug', slug);
    };

    return (
        <div className={`departments card ${isLoadingDepartments && ' loading'}`}>
            {isLoadingDepartments ? (
                [...Array(8)].map((_, i) => (
                    <div className="card-content" key={i}>
                        <a>
                            <i className="fa fa-folder"></i>
                            <span>Loading...</span>
                        </a>
                    </div>
                ))
            ) : ((role === 'admin' || role === 'management')
                    ? (departments?.map(({ id, department, slug }) => (
                        <div className="card-content" key={id}>
                            <NavLink 
                                to={`/dtr/timesheets/${slug}`} 
                                title={department} 
                                onClick={() => handleSetTimesheetChildData(department, slug)}
                                aria-label={`Navigate to timesheets for ${department}`}
                            >
                                <i className="fa fa-folder"></i>
                                <span>{department}</span>
                            </NavLink>
                        </div>
                    ))) : (
                        accessibleDepartments?.length > 0 && (accessibleDepartments?.map((item, i) => (
                            <div className="card-content" key={i}>
                                <NavLink 
                                    to={`/dtr/timesheets/${item.department_code}`} 
                                    title={item.department} 
                                    onClick={() => handleSetTimesheetChildData(item.department, item.department_code)}
                                    aria-label={`Navigate to timesheets for ${item.department}`}
                                >
                                    <i className="fa fa-folder"></i>
                                    <span>{item.department}</span>
                                </NavLink>
                            </div>
                        )))
                    )
                )}
        </div>
    );
};

export default Department;
